import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "../lib/apiClient";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("yatto_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api
            .get("/auth/me")
            .then((r) => setAdmin(r.data))
            .catch(() => {
                localStorage.removeItem("yatto_token");
                setAdmin(null);
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("yatto_token", data.token);
        setAdmin({ email: data.email });
        return data;
    };

    const logout = useCallback(() => {
        localStorage.removeItem("yatto_token");
        setAdmin(null);
    }, []);

    const value = useMemo(() => ({ admin, loading, login, logout }), [admin, loading, logout]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
